import { createSiteSchema } from './schemas/create_site_schema';

app.NewSiteDetailsView = app.BaseDetailsView.extend({
  initialize(options) {
    options.dismissOnSave = true;

    app.BaseDetailsView.prototype.initialize.apply(this, arguments);
  },

  getSchema() {
    return createSiteSchema;
  },

  _didSaveModel() {
    app.showSavedToast('Created a New Site!');
    setTimeout(() => {
      window.location.href = this.model.bureauUrl();
    }, 1500);
  },
});
